import { Card, CardBody, Row, Col, Input, Label } from "reactstrap";
import React, { useState } from "react";
import { Loader } from "../../../custom/components/Loader";
import { resubmitVesselRequest } from "../../../api/controller/MyVesselController";
import { handleResponse } from "../../../custom/helpers/HandleResponse";

const ResubmitVessel = ({ vessel, setCurrentScreen, refreshMyVessels }) => {
    const [loading, setLoading] = useState(false);
    // VesselType is preserved as the vessel's existing type (no type-change UI this iteration); the resubmit API requires it.
    const [form, setForm] = useState({
        VesselType: vessel?.vessel_type_id || "",
        Name: vessel?.name || "",
        Length: vessel?.length || "",
        Breadth: vessel?.breadth || "",
        GrossTonnage: vessel?.gross_tonnage || "",
        RepresentativeName: vessel?.representative_name || "",
        RepresentativeContactNumber: vessel?.representative_contact_number || "",
    });

    const setField = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const onSubmit = async () => {
        if (!vessel || !vessel.id) { return; }
        if (!form.Name.trim() || form.Length === "" || form.Breadth === "" || form.GrossTonnage === "" || !form.RepresentativeName.trim()) {
            handleResponse({ Status: "error", Message: "Please fill in all required fields." });
            return;
        }
        if (!/^[7936]\d{6}$/.test(form.RepresentativeContactNumber)) {
            handleResponse({ Status: "error", Message: "Contact number must be 7 digits starting with 7, 9, 3 or 6." });
            return;
        }
        const unchanged =
            String(form.VesselType) === String(vessel?.vessel_type_id ?? "") &&
            form.Name === (vessel?.name ?? "") &&
            String(form.Length) === String(vessel?.length ?? "") &&
            String(form.Breadth) === String(vessel?.breadth ?? "") &&
            String(form.GrossTonnage) === String(vessel?.gross_tonnage ?? "") &&
            form.RepresentativeName === (vessel?.representative_name ?? "") &&
            form.RepresentativeContactNumber === (vessel?.representative_contact_number ?? "");
        if (unchanged) {
            handleResponse({ Status: "error", Message: "Please make a change before resubmitting." });
            return;
        }
        setLoading(true);
        const res = await resubmitVesselRequest({ id: vessel.id, ...form });
        setLoading(false);
        handleResponse(res);
        if (res?.Status === "success") { if (refreshMyVessels) refreshMyVessels(); setCurrentScreen("myVessels"); }
    };

    return (
        <React.Fragment>
            <Loader loading={loading} transparent />
            <button className="btn btn-primary fs-6 py-1" onClick={() => setCurrentScreen("myVessels")}>
                <span className="mdi mdi-chevron-left align-middle fs-3 me-2"></span><span className="fs-6">Back</span>
            </button>
            <Card className="mt-4">
                <CardBody>
                    <h4>Resubmit Vessel</h4>
                    {vessel?.rejection_reason && (
                        <div className="alert alert-danger mt-2"><b>Rejection reason:</b> {vessel.rejection_reason}</div>
                    )}
                    <Row className="mt-2">
                        <Col xs={12} md={6} className="mb-3"><Label>Registration Number</Label><Input value={vessel?.registration_number || ""} readOnly /></Col>
                        <Col xs={12} md={6} className="mb-3"><Label>Name</Label><Input value={form.Name} onChange={setField("Name")} /></Col>
                        <Col xs={12} md={4} className="mb-3"><Label>Length (m)</Label><Input type="number" step="any" min="0" value={form.Length} onChange={setField("Length")} /></Col>
                        <Col xs={12} md={4} className="mb-3"><Label>Breadth (m)</Label><Input type="number" step="any" min="0" value={form.Breadth} onChange={setField("Breadth")} /></Col>
                        <Col xs={12} md={4} className="mb-3"><Label>Gross Tonnage</Label><Input type="number" step="any" min="0" value={form.GrossTonnage} onChange={setField("GrossTonnage")} /></Col>
                        <Col xs={12} md={6} className="mb-3"><Label>Representative Name</Label><Input value={form.RepresentativeName} onChange={setField("RepresentativeName")} /></Col>
                        <Col xs={12} md={6} className="mb-3"><Label>Representative Contact Number</Label><Input maxLength={7} inputMode="numeric" value={form.RepresentativeContactNumber} onChange={(e) => setForm({ ...form, RepresentativeContactNumber: e.target.value.replace(/\D/g, "").slice(0, 7) })} /></Col>
                    </Row>
                    <button className="btn btn-primary" disabled={loading} onClick={onSubmit}>Resubmit</button>
                </CardBody>
            </Card>
        </React.Fragment>
    );
};
export default ResubmitVessel;
